export const environment = {
    production: false,

    apiVersion: 'v1.0',
    apiUrl: 'https://dev.myvetbusiness.it/',
    siteUrl: 'https://dev.myvetdiet.it/',

    appUrl: 'https://dev.app.myvet.it/'
};
